import "./about.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons';

const About = ()=>{
  return (
    <div className="about">
      
      <div className="about__section">
        <h1 className="title">About Us</h1>
        <div className="text">
        Raydron Equipment is a subsidiary of Raydron Nigeria Limited, founded in 2016, but started operating fully as an equipment manufacturer in 2023. We specialize in building industrial equipment, tools and appliances locally. The equipment we build include:
        <ul>
          <li className="advantage">
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Gas-fired Smelting Furnaces for melting Aluminium, Copper & Brass
          </li>
          <li className="advantage">
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Oil-fired Smelting Furnaces for melting Aluminium, Copper, Brass & Cast Iron
          </li>
          <li className="advantage">
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Induction Furnaces for melting Cast Iron, Steel, and non-ferrous alloys
          </li>
          <li className="advantage">
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Plastic Extruders
          </li>
          <li className="advantage">
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Wire Extruder Presses
          </li>
          <li className="advantage">
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Wire Drawing Machines
          </li>
          <li className="advantage">
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Hydraulic Power Systems
          </li>
          <li className="advantage">
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Other custom equipment as required by our clients
          </li>
        </ul>
        </div>
        <div className="about__banner">
        <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730879424/rotary_furnace_jbnbgk.png" alt="about_banner2" className="banner_img" />
      </div>
        {/* <blockquote className="quote"><span className="quote__mark"><FontAwesomeIcon icon={faQuoteLeft}/></span>
        We remain committed to ensuring that every piece of apparel that leaves our factory is free from every form of defect.<span className="quote__mark"><FontAwesomeIcon icon={faQuoteRight}/></span></blockquote> */}
        <div className="column">
        <div className="text">
        We also run a small foundry where we manufacture castings such as:
        <ul>
          <li>
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Manhole Covers
          </li>
          <li>
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Gully Gratings
          </li>
          <li>
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Industrial Valves & Fittings
          </li>
          <li>
          <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span> Other custom castings as required by our customers
          </li>
        </ul>
        
        </div>
        <div>
        <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730884350/Manhole_Cover_cfutsu.png" alt="about_banner3" className="banner_imgflex" />
        </div>
        </div>
        <h2 className="title">
        Our Mission Statement
        </h2>
        <blockquote className="quote"><span className="quote__mark"><FontAwesomeIcon icon={faQuoteLeft}/></span>
        To continuously provide a wide range of reliable and affordable industrial equipment and tools to our customers while adhering to the industry's best practices.<span className="quote__mark"><FontAwesomeIcon icon={faQuoteRight}/></span></blockquote>
        <h2 className="title">
        Our Competitive Advantage
        </h2>
        <div className="text">
          <ul>
            <li className="advantage">
            <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Local Focus: tailoring our manufacturing operations to first and foremost to companies operating in Nigeria helps our customers to avoid long downtimes associated with relying on overseas equipment suppliers. Our local clients can easily access spare parts, technical support and equipment operations training easily.
            </li>
            <li className="advantage">
            <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Quality Craftmanship: starting from 3D CAD design using the state-of-the-art drafting systems to production planning to the actual equipment construction, our team employs the best processes to deliver the highest standard of equipment.
            </li>
            <li className="advantage">
            <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Personalized Service: each project begins with a consultation with our client to understand their unique requirements and vision
            </li>
            <li className="advantage">
            <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Eco-friendly: We prioritize sustainable materials and practices to minimize our environmental impact.
            </li>
          </ul>
        </div>
        <div className="about__banner">
        <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1730879282/shredder_2_rucd7z.png" alt="about_banner" className="banner_img" />
      </div>
      <h2 className="title">
        Tools and Technology
      </h2>
      <div className="text tools">
          <ul>
            <li >
            <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>3D CAD & CAM
            </li>
            <li>
            <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>CNC Machining
            </li>
            <li>
            <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Laser Cutting
            </li>
            <li>
            <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Milling Machines
            </li>
            <li>
            <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Lathe Machines
            </li>
            <li>
            <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Welding Machines
            </li>
          </ul>
      </div>
      </div>
    </div>
  )
}

export default About